import {LnxTableLocalization} from "./lnx_table_localization";
import {throttle} from "./common_methods";
import 'datatables.net-bs4';
import $ from "jquery";

export class Lnxtable {
  constructor(_at_self) {
    this.self = _at_self;
    this.options = {
      'dom': 't<"tfooter d-flex justify-content-end align-items-end"ip>',
      'aaSorting': [],
      'language': new LnxTableLocalization().locale($('meta[name=language]').attr('content')),
      "stateSave": true,
      'stateSaveParams': this.fillSearch,
      'columnDefs': _at_self.data('columnsdef'),
      'initComplete': function() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }
    };
    if (_at_self.data('columnsdef') !== undefined) {
      this.options['autoWidth'] = false;
    }
    this.searchField = $("input#search");
    this.tableApi = void 0;
    this.init();
  }

  init = function () {
    if ($.fn.DataTable.isDataTable(this.self)) {
      return;
    }
    this.tableApi = this.self.DataTable(this.options);
    this.searchField.on('input', (function (_this) {
      return function (e) {
        throttle(function () {
          return _this.tableApi.search(e.currentTarget.value).draw();
        });
      };
    })(this));

    const $filterCheckboxes = $('input[type=checkbox][data-filter=true]');
    $filterCheckboxes.on('change', () => {
      const filters = [];
      $filterCheckboxes.each((_idx, checkbox) => {
        if (checkbox.checked) {
          filters.push(checkbox.dataset.filterName);
        }
      });

      const url = new URL(window.location.href);
      url.searchParams.delete('filter');
      if (filters.length > 0) {
        url.searchParams.append('filter', filters.join(','));
      }
      window.location.href = url.toString();
    });
  };

  fillSearch = function (settings, data) {
    //HACK
    const searchField = $("input#search");
    if (!searchField.val()) {
      searchField.val(data.search.search);
    }
  };
}